import Renderer from 'apollo-e/rendering/Renderer';
import Object3D from 'apollo-e/rendering/Object3D';
import Mesh3D_TRIANGLE_normal_uv from 'apollo-e/meshes/Mesh3D_TRIANGLE_normal_uv';
import { Shader, VertexShader, FragmentShader, ShaderProgram } from 'apollo-e/rendering/Shader';
import QuadGeometry from 'apollo-e/geometries/QuadGeometry';

import opacities from 'apollo-e/rendering/OPACITIES';
const transluscent = opacities.TRANSLUSCENT;

const defaultVertexScript = require('./shaders/vertex/qta.vert');
const defaultFragmentScript = require('./shaders/fragment/qta.frag');

// const depthVertexScript = require('./shaders/vertex/qtaDepth.vert');
// const depthFragmentScript = require('./shaders/fragment/qtaDepth.frag');

// const shadedVertexScript = require('./shaders/vertex/qtaShaded.vert');
// const shadedFragmentScript = require('./shaders/fragment/qtaShaded.frag');

const defaultVertexShader = new VertexShader(defaultVertexScript, ['aVertexPosition', 'aVertexNormal', 'aUV'], ['uMMatrix', 'uCameraPosition']);
const defaultFragmentShader = new FragmentShader(defaultFragmentScript, ['uAmbientLight', 'uDirectionalLight', 'uLightDirection'], ['uTexture']);
const defaultShader = new Shader(defaultVertexShader, defaultFragmentShader);

// const depthVertexShader = new VertexShader(depthVertexScript, ['aVertexPosition', 'aUV'], ['uMMatrix']);
// const depthFragmentShader = new FragmentShader(depthFragmentScript, [], ['uTexture']);
// const depthShader = new Shader(depthVertexShader, depthFragmentShader);

// const shadedVertexShader = new VertexShader(shadedVertexScript, ['aVertexPosition', 'aVertexNormal', 'aUV'], ['uMMatrix', 'uCameraPosition', 'uShadowMapVPMatrix']);
// const shadedFragmentShader = new FragmentShader(shadedFragmentScript, ['uAmbientLight', 'uDirectionalLight', 'uLightDirection'], ['uTexture', 'uShadowMap']);
// const shadedShader = new Shader(shadedVertexShader, shadedFragmentShader);

const shaders = {
	default: defaultShader,
	// depth: depthShader,
	// shaded: shadedShader
};

const quadMesh = new Mesh3D_TRIANGLE_normal_uv(new QuadGeometry());

export default class QT3D extends Object3D {
	mesh: Mesh3D_TRIANGLE_normal_uv;

	shaders = shaders;

	constructor () {
		super();

		this.opacity = transluscent;
		this.mesh = quadMesh;
	}

	renderDefault (renderer: Renderer, program: ShaderProgram) {
		this.mesh.render(renderer, program, true);
	}

	// renderDepth (renderer: Renderer, program: ShaderProgram) {
	// 	this.mesh.render(renderer, program, false);
	// }

	// renderShaded = this.renderDefault
	
}
